// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","selectInput":"selectInput-MwKnu","form":"form-19CNe"};